import "./shared"
import { Loader, AddressLoader, Cep, Confetti, AutoComplete, autoDetectAndViewImage, detectType, toggleVisibility } from "./shared"

export default { Loader, AddressLoader, Confetti, Cep, AutoComplete, autoDetectAndViewImage, detectType, toggleVisibility };


window.AddressLoader = AddressLoader;
